import { calcDateTime, formatDuration, intervalToDuration } from '@occc-app/lib/date';

export const getDateRange = () => {
  const now = new Date();

  return {
    startDate: calcDateTime(now, 'sub', 1, 'week').toISOString(), // Default to 1 week ago. Should be configurable by filters in the text ticket.
    endDate: now.toISOString(),
  };
};

export const customFormatDuration = ({ start, end }: { start: number; end: number }) => {
  const durations = intervalToDuration({ start, end });
  return formatDuration(durations);
};

export const formatDurationTime = (duration?: number | null): string => {
  if (duration === undefined || duration === null || duration === 0) {
    return '0';
  }

  if (duration < 1000) {
    return `${duration} ms`;
  }

  const durations = intervalToDuration({ start: 0, end: duration });
  return formatDuration(durations)
    .replace(/hours?/, 'h')
    .replace(/minutes?/, 'min')
    .replace(/seconds?/, 's')
    .replace(/days?/, 'd');
};
